import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, PayPalButton } from 'src/components'

type Props = {
  isOpen: boolean
  setOpen: (state: boolean) => void
  title: string
}

export default ({ isOpen, setOpen, title }: Props) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} setOpen={setOpen} title={title}>
      <span>{t('modals.about.info1')}</span>
      <span>{t('modals.about.info2')}</span>

      <span>
        {t('modals.about.info3')}
        <br />
        <a
          href="https://github.com/averted"
          target="_blank"
          rel="noopener noreferrer"
        >
          averted
        </a>
        <br />
        <a
          href="https://github.com/av-x"
          target="_blank"
          rel="noopener noreferrer"
        >
          av-x
        </a>
      </span>

      <span>
        {t('modals.about.comments_suggestions')}{' '}
        <a href="mailto:tarkovapp@pm.me">{t('util.email')}</a>.
      </span>

      <span>{t('modals.about.donation')}</span>

      <PayPalButton />
    </Modal>
  )
}
